
    const data = {"name":"src/core/icons/less-than","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m18.5 4.14 1 1.72L8.97 12l10.53 6.14-1 1.72L5 12l13.5-7.86Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            